import React, { useMemo } from 'react';
import { ITag } from '../../../../../../entities/module/private-template-module-tag/api/types';
import { ModuleGroupTag } from '../tag/ModuleGroupTag';
import css from './TagsScrollSearchList.module.scss';
import { useAppDispatch } from '../../../../../../shared/libs/redux';
import { useActionCreators } from '../../../../../../shared';
import { templateTagActions } from '../../../../../../entities/template/private-template-tag';
import { CreateTagDropdown } from '../../../../../create-tag-dropdown';
import { ITemplateTag } from '../../../../../../entities/template/private-template-tag/model/types/types';

interface TagsScrollSearchListProps {
	currentIds: number[],
	tags: ITag[] | undefined,
	fromTemplates?: ITemplateTag[],
	onSelectTag: (id: number) => void,
	search: string;
	onCreateTag: (name: string) => Promise<void>;
	onAddChoicedItem?: (id: string) => void;
	onRemoveChoicedItem?: (id: string) => void;
	isControlsHidden?: boolean,
	setSearch: (value: string) => void,
}

export const TagsScrollSearchList = ({
	tags,
	fromTemplates = [],
	currentIds,
	onSelectTag,
	search,
	onCreateTag,
	onAddChoicedItem,
	onRemoveChoicedItem,
	isControlsHidden = false,
	setSearch,
}: TagsScrollSearchListProps) => {
	const dispatch = useAppDispatch();
	const actions = useActionCreators(templateTagActions);

	const onTagClick = (tag: ITag) => {
		if (currentIds.includes(tag.id)) {
			onRemoveChoicedItem?.(String(tag.id));
		} else {
			onAddChoicedItem?.(String(tag.id));
		}
	};

	const onEditingTag = (id: number) => {
		dispatch(actions.setEditingTagId(id));
		dispatch(actions.setIsEditingTagModalActive(true));
	};

	const onDeletingTag = (id: number) => {
		dispatch(actions.setDeletingTagId(id));
		dispatch(actions.setIsDeletingTagModalActive(true));
	};

	const sortedTags = useMemo(() => {
		if (!tags) return [];

		return [...tags].sort((a, b) => {
			const aSelected = currentIds.includes(a.id) ? -1 : 1;
			const bSelected = currentIds.includes(b.id) ? -1 : 1;
			return aSelected - bSelected;
		});
	}, [tags, currentIds]);

	return (
		<div className={css.wrapper}>
			{sortedTags.length ? (
				sortedTags.map(tag => {
					const isTagActive = (fromTemplates?.some(
						templateTag => templateTag.id === tag.id,
					) || currentIds.includes(tag.id));

					return (
						<ModuleGroupTag
							tag={tag}
							key={tag.id}
							onClick={() => {
								onTagClick(tag);
								onSelectTag(tag.id);
							}}
							onEdit={isControlsHidden ? undefined : () => onEditingTag(tag.id)}
							onDelete={isControlsHidden ? undefined : () => onDeletingTag(tag.id)}
							isActive={isTagActive}
							search={search}
						/>
					);
				})
			) : (
				<CreateTagDropdown
					creatingTagName={search}
					data={tags}
					createTag={onCreateTag}
					onTagClick={onTagClick}
					setSearch={setSearch}
				/>
			)}
		</div>
	);
};
